var exports = {
  "kL": "NoteEditSheet.module__container___U1Zibk",
  "Gv": "NoteEditSheet.module__backButton___U1Zibk",
  "j2": "NoteEditSheet.module__backIcon___U1Zibk",
  "eG": "NoteEditSheet.module__saveButton___U1Zibk",
  "AW": "NoteEditSheet.module__saveButtonActive___U1Zibk",
  "Qs": "NoteEditSheet.module__content___U1Zibk",
  "Pf": "NoteEditSheet.module__label___U1Zibk",
  "PC": "NoteEditSheet.module__textarea___U1Zibk",
};

module.exports = exports;
